import { initFullpage } from './modules/init-fullpage'
import { initEventsCalendar } from './modules/init-events-calendar'
import { initHighContrast } from './modules/init-high-contrast'
import { initLocationsCarousel } from './modules/init-locations-carousel'

document.addEventListener('DOMContentLoaded', () => {
	initHighContrast()
	initFullpage()
	initEventsCalendar()
	initLocationsCarousel()
})
